import * as eventosStore from './store'

export function eventosModule({ store }) {
  store.registerModule('eventos', {
    ...eventosStore,
    namespaced: true,
  })
}
